module.exports = __webpack_public_path__ + "static/media/4QPF.d0d9d1f5.png";